<template>
  <article class="registration-2" v-if="user">
    <header class="registration-2__header">
      <!-- <h1 class="registration-2__title">
        Boa tarde, dr{{user.gender === 'F' ? '&ordf;' : ''}}. {{user.displayName || user.name}}
      </h1> -->

      <!-- <p class="registration-2__greeting">
        Parabéns! Você foi aprovad{{user.gender === 'F' ? 'a' : 'o'}} para fazer parte
        da maior rede de médicos especialistas do Brasil.<br />
        Agora, termine de preencher o seu cadastro para começar a usar o Dr. Conecta.
      </p> -->
      <h1 class="registration-2_title text-center">
        Vamos cadastrar o seu consultório<br /><br />
      </h1>
    </header>

    <div class="registration-2__details">
      <h6 class="registration-2__doctor">
        {{user.name}}
      </h6>

      <dl class="registration-2__info">
        <dt class="registration-2__term">CRM</dt>
        <dd class="registration-2__def">{{ user.crm }}</dd>
      </dl>

      <dl class="registration-2__info">
        <dt class="registration-2__term">E-mail</dt>
        <dd class="registration-2__def">{{ user.email }}</dd>
      </dl>

      <dl class="registration-2__info">
        <dt class="registration-2__term">Telefone</dt>
        <dd class="registration-2__def">{{ user.contact_phone | TO_TEL }}</dd>
      </dl>
    </div>

    <form @submit.prevent="submit()" class="registration-2__form">
      <dr-field
        class="text-left"
        prefix="form1"
        v-for="(field, name) in formData"
        :form.sync="formData"
        :field.sync="field"
        :validators.sync="$v.formData[name]"
        :apiErrors.sync="apiErrors[name]"
        :id="name"
        :ref="name"
        :key="'main_'+name"
      />

      <p class="text-warning col-12 text-center" v-if="$v.$invalid && formSent">
        Por favor complete o formulário corretamente
      </p>

      <div class="column form-group col-12 text-center">
        <dr-submit :disabled="$v.$invalid" text="Avançar" :sending="sending" />
      </div>
    </form>
  </article>
</template>

<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import {formData, validations} from '@/data/formData//registration.js'
// import { sameAs } from 'vuelidate/lib/validators'

export default {
  components: {
    drField,
    drSubmit
  },
  props: ['user'],
  data () {
    return {
      loaded: true,
      validCep: false,
      formSent: false,
      sending: false,
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      formData: formData
    }
  },
  validations: {
    formData: validations
  },
  mounted () {
    this.fn_HIDE_PROGRESS()
    for (let field in this.formData) {
      this.formData[field].value = null
    }
  },
  computed: {
    watchCep () {
      if (this.formData) {
        return this.formData['doctorOffices.0.address.cep'].value
      }
      return ''
    }
  },
  watch: {
    'watchCep': function (next, prev) {
      if (next.length === 9) {
        this.getCep(next)
      }
    }
  },
  methods: {
    submit () {
      this.apiErrors = this.fn_BUILD_API_ERRORS(formData)
      this.sending = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.sending = false
        return
      }
      this.fn_SHOW_PROGRESS()
      let data = this.fn_COPY_OBJECT(this.formData)

      data['doctorOffices.0.address.cep'].value = this.fn_NUMBERS_ONLY(data['doctorOffices.0.address.cep'].value)
      // data.isAcceptTermsUse = {
      //   value: 1
      // }

      this.$http.get(`https://maps.google.com/maps/api/geocode/json?key=${this.$store.getters.$_getMapsApi}&address=${this.formData['doctorOffices.0.address.street'].value + ', ' + this.formData['doctorOffices.0.address.number'].value}`).then(
        (res) => {
          if (res.data.results.length === 0) {
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
            this.sending = false
            this.fn_HIDE_PROGRESS()
            return
          }
          this.formData['doctorOffices.0.address.latitude'].value = res.data.results[0].geometry.location.lat
          this.formData['doctorOffices.0.address.longitude'].value = res.data.results[0].geometry.location.lng

          data = this.fn_EXPAND_OBJECT(data)

          this.$http.put('/doctor/registration', {'registration': data}, this.$store.getters.getAuthHeader).then(
            (res) => {
              this.sending = false
              this.fn_HIDE_PROGRESS()
              this.$router.push({name: 'RegisterRegistrationSuccess'})
            }
          ).catch(
            (err) => {
              this.fn_HIDE_PROGRESS()
              console.log(err, data)

              if (err.status === 400 || err.code === 400) {
                this.fn_FLATTEN_OBJECT(err.errors.children).then(
                  (res) => {
                    for (let field in res) {
                      this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                    }
                    this.sending = false
                    this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.form)
                  }
                )
              } else {
                console.log(err)
                this.sending = false
                this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
              }// s
            }
          )
        }
      )
    },
    getCep (v) {
      const self = this
      self.formData['doctorOffices.0.address.cep'].loading = 1
      function handleData (res) {
        if (!res) {
          self.formData['doctorOffices.0.address.cep'].loading = 0
          self.validCep = false
          return
        }
        let cep = {}
        if (res.data.erro) {
          self.validCep = false
          cep.uf = ''
        } else {
          self.validCep = true
          cep = res.data
          cep.uf = self.fn_FIND_UF_CODE(cep.uf).id
        }
        self.formData['doctorOffices.0.address.city.name'].value = cep.localidade || null
        self.formData['doctorOffices.0.address.uf'].value = cep.uf || null
        self.formData['doctorOffices.0.address.district'].value = cep.bairro || null
        self.formData['doctorOffices.0.address.street'].value = cep.logradouro || null

        setTimeout(() => {
          self.formData['doctorOffices.0.address.cep'].loading = 0
        }, 500)
      }
      if (v.length === 9) {
        this.$http.get('https://viacep.com.br/ws/' + v.replace('-', '') + '/json/').then(
          (res) => {
            if (res.data.erro) {
              self.formData.cep.loading = 0
              this.validCep = false
            }
            handleData(res)
            this.$http.get(`https://maps.google.com/maps/api/geocode/json?key=${this.$store.getters.$_getMapsApi}&address=${res.data.logradouro}`).then(
              (res) => {
                this.formData['doctorOffices.0.address.latitude'].value = res.data.results[0].geometry.location.lat
                this.formData['doctorOffices.0.address.longitude'].value = res.data.results[0].geometry.location.lng
              }
            )
          }
        ).catch(
          (err) => {
            handleData()
            console.log(err)
          }
        )
      }
    }
  },
  directives: {
    'get-cep': {
      bind (el, bind, vnode) {

      }
    }
  }
}
</script>
